import React from 'react';
import { Controller } from 'react-hook-form';
import { DatePicker } from '../DatePicker/DatePicker';
import { useFormContext } from './FormProvider';
import PropTypes from 'prop-types';

export const FormDatePicker = ({ name, ...props }) => {
  const { control, formConfig } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <DatePicker
          {...field}
          {...formConfig}
          {...props}
          error={!!error}
          helperText={error?.message ? error?.message : props.helperText}
        />
      )}
    />
  );
};

FormDatePicker.propTypes = {
  name: PropTypes.string.isRequired,
}; 